import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Member.css";
import { Helmet } from "react-helmet-async";
import discord_logo from "../../assets/hiveport_page/discord_logo.png";
import behance_logo from "../../assets/hiveport_page/behance_logo.png";
import instagram_logo from "../../assets/hiveport_page/instagram_logo.png";
import youtube_logo from "../../assets/hiveport_page/youtube_logo.png";
import lupus_photo from "../../assets/ourteampage/member_boxes/member_photos/lupus_photo.png";
import merilus_photo from "../../assets/ourteampage/member_boxes/member_photos/merilus_photo.png";
import korupt_photo from "../../assets/ourteampage/member_boxes/member_photos/korupt_photo.png";
import mario_photo from "../../assets/ourteampage/member_boxes/member_photos/mario_photo.png";
import merilusBanner from "../../assets/member_port/merilus/merila_banner.png";
import lupusBanner from "../../assets/member_port/justlupus/merila_banner.png";
import ps from "../../assets/member_port/skill_icons/ps.png";
import ae from "../../assets/member_port/skill_icons/ae.png";
import pr from "../../assets/member_port/skill_icons/pr.png";
import ui from "../../assets/member_port/skill_icons/ui.png";
import brand from "../../assets/member_port/skill_icons/brand.png";
import Projects from "../contexts_config/Projects";
import ProjectShowcase from "../project_showcase/ProjectShowcase";
import Footer from "../footer/Footer";

const memberProfiles = {
  lupus: {
    name: "Pradais Samuel",
    role: "Web Developer",
    location: "Romania",
    photo: lupus_photo,
    banner: lupusBanner,
    skills: [
      { icon: ui, label: "WEB DEVELOPMENT" },
      { icon: ui, label: "FIVEM DEVELOPMENT" },
      { icon: ps, label: "SYSTEMS DESIGN" },
      { icon: brand, label: "SERVER SETUP" },
    ],
  },
  merilus: {
    name: "Merila Cosmin",
    role: "Graphic Designer",
    location: "Moldova, Chisinau",
    photo: merilus_photo,
    banner: merilusBanner,
    skills: [
      { icon: ps, label: "GRAPHIC DESIGN" },
      { icon: ae, label: "MOTION DESIGN" },
      { icon: pr, label: "VIDEO EDITING" },
      { icon: ui, label: "UI/UX DESIGN" },
      { icon: brand, label: "BRAND DESIGN" },
    ],
  },
  korrupt: {
    name: "Adrian G.",
    role: "Backend Developer",
    location: "Bucharest, Romania",
    photo: korupt_photo,
    banner: lupusBanner,
    skills: [
      { icon: ps, label: "BACKEND" },
      { icon: ui, label: "INFRASTRUCTURE" },
      { icon: brand, label: "APIS" },
    ],
  },
  mariommm: {
    name: "Mario M.",
    role: "UI Designer",
    location: "Romania",
    photo: mario_photo,
    banner: lupusBanner,
    skills: [
      { icon: ui, label: "UI/UX DESIGN" },
      { icon: ps, label: "VISUAL DESIGN" },
      { icon: brand, label: "BRAND SYSTEMS" },
    ],
  },
};

const Member = ({ memberSlug: propSlug }) => {
  const { memberSlug: routeSlug } = useParams();
  const slug = propSlug || routeSlug || "merilus";
  const member = memberProfiles[slug] || memberProfiles.merilus;

  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const memberProjects = Projects.filter((project) =>
    project.members.includes(member.name),
  );

  useEffect(() => {
    // Ensure both window and main content container are scrolled to top
    window.scrollTo({ top: 0, behavior: "auto" });
    const content = document.querySelector(".websiteContent");
    if (content) {
      content.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [slug]);

  const isJustLupus = slug === "lupus";
  const memberTitle = isJustLupus
    ? "Pradais Samuel (JustLupus) | Web Developer la HiveTeam"
    : `${member.name} | ${member.role} la HiveTeam`;
  const memberDescription = isJustLupus
    ? "Pradais Samuel (JustLupus) este Web Developer la HiveTeam. Pagina oficiala cu proiecte, competente si profil profesional pe hiveteam.dev/justlupus."
    : `${member.name} - ${member.role} la HiveTeam. HiveTeam dezvolta website-uri moderne, identitate de brand si graphic design pentru business-uri care vor o prezenta online clara si profesionala.`;
  const memberKeywords = [
    "HiveTeam",
    member.name,
    member.role,
    "Creare site-uri web",
    "web design",
    "brand identity",
    "graphic design",
    "branding designer",
    "UI UX",
    "identitate vizuala",
    "logo design",
    "Romania",
  ].join(", ");

  const memberOrigin =
    typeof window !== "undefined"
      ? window.location.origin
      : "https://hiveteam.dev";

  const memberImage = member.banner || member.photo || "";
  const memberImageUrl = memberImage.startsWith("http")
    ? memberImage
    : `${memberOrigin}${memberImage}`;

  const bannerStyle = member.banner
    ? { backgroundImage: `url(${member.banner})` }
    : { background: "linear-gradient(120deg, #0a1a2f, #0f2740)" };

  const memberUrl = isJustLupus
    ? "https://hiveteam.dev/justlupus"
    : `https://hiveteam.dev/${slug || ""}`;

  const memberSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: member.name,
    alternateName: isJustLupus ? ["JustLupus", "Pradais Samuel"] : undefined,
    jobTitle: member.role,
    worksFor: {
      "@type": "Organization",
      name: "HiveTeam",
      url: "https://hiveteam.dev",
    },
    image: memberImageUrl,
    url: memberUrl,
    knowsAbout: [
      "creare site-uri web",
      "brand identity",
      "graphic design",
      "UI/UX",
      "web design",
    ],
    address: {
      "@type": "PostalAddress",
      addressCountry: "RO",
    },
    sameAs: isJustLupus
      ? ["https://hiveteam.dev/justlupus", "https://hiveteam.dev/lupus"]
      : undefined,
  };

  return (
    <div className="memberPage">
      <Helmet>
        <title>{memberTitle}</title>
        <meta name="description" content={memberDescription} />
        <meta name="keywords" content={memberKeywords} />
        <meta property="og:title" content={memberTitle} />
        <meta property="og:description" content={memberDescription} />
        <meta property="og:type" content="profile" />
        <meta property="og:image" content={memberImageUrl} />
        <link rel="canonical" href={memberUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={memberTitle} />
        <meta name="twitter:description" content={memberDescription} />
        <meta name="twitter:image" content={memberImageUrl} />
        <script type="application/ld+json">
          {JSON.stringify(memberSchema)}
        </script>
      </Helmet>
      {selectedProjectId && (
        <ProjectShowcase
          projectId={selectedProjectId}
          onClose={() => setSelectedProjectId(null)}
        />
      )}
      <div className="member_container">
        <div className="top_member">
          <div className="banner_part" style={bannerStyle}></div>
          <div className="bottom_part">
            <div className="social_media_part">
              <div className="text">SOCIAL MEDIA</div>
              <div className="icons_part">
                <a
                  className="icon_box"
                  href="https://www.youtube.com/@hiveteam"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open HiveTeam YouTube"
                >
                  <img src={youtube_logo} alt="YouTube" />
                </a>
                <a
                  className="icon_box"
                  href="https://www.instagram.com/hive.team/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open HiveTeam Instagram"
                >
                  <img src={instagram_logo} alt="Instagram" />
                </a>
                <a
                  className="icon_box"
                  href="https://discord.gg/hiveteam"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open HiveTeam Discord"
                >
                  <img src={discord_logo} alt="Discord" />
                </a>
                <a
                  className="icon_box"
                  href="https://www.behance.net/hiveteam"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open HiveTeam Behance"
                >
                  <img src={behance_logo} alt="Behance" />
                </a>
              </div>
            </div>
          </div>

          <div className="member_details">
            <img
              className="logo_member"
              src={member.photo}
              alt={`${member.name} profile`}
            />
            <div className="details_member">
              <div className="member_rol">
                <p>{member.role}</p> <div className="liniuta"></div>
              </div>

              <div className="member_names">
                <h1>{member.name}</h1>
                <p>{member.location}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="member_skills">
          {member.skills.map((skill, index) => (
            <div className="skill_box" key={index}>
              <div className="top_skill">
                <div className="skil_icon">
                  <img src={skill.icon} alt={`${skill.label} icon`} />
                </div>
                <div className="skill_bar"></div>
                <svg
                  width="30"
                  height="42"
                  viewBox="0 0 30 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.4915 41.58V0H30V42L0 41.79L29.4915 41.58Z"
                    fill="white"
                    fillOpacity="0.63"
                  />
                </svg>
              </div>

              <p>{skill.label}</p>
            </div>
          ))}
        </div>

        <div className="member_project">
          {memberProjects.map((project, index) => (
            <div className="project_box" key={index}>
              <div className="project_photo">
                <img src={project.headerImage} alt={project.title} />
              </div>
              <div className="proj_details">
                <h1>
                  {project.title} | {project.subtitle}
                </h1>
                <button
                  type="button"
                  onClick={() => setSelectedProjectId(project.id)}
                  aria-label={`View more information about ${project.title}`}
                >
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.44696 8.16919L8.66113 5.7847M8.66113 5.7847L6.44696 3.4002M8.66113 5.7847H3.3278C2.40733 5.7847 1.66113 4.98109 1.66113 3.98983V1.16919"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p>MORE INFORMATION</p>
                </button>
              </div>
            </div>
          ))}
          <div className="member_project_footer"></div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Member;
